import { SpanStatusCode } from '@opentelemetry/api';
import { getCustomTracer } from '@splunk/olly-tracing/getCustomTracer';

export const LOGIN_TYPES = Object.freeze({
    PASSWORD: 'password',
    GOOGLE: 'google',
    SAML_SSO: 'saml_sso',
    OIDC_SSO: 'oidc_sso',
});

const LOGIN_WORKFLOW_NAME = 'login';
const LOGIN_TYPE_ATTRIBUTE = 'ieiam.login.type';

export function startLoginWorkflow(loginType) {
    const span = getCustomTracer().startSpan(LOGIN_WORKFLOW_NAME, {
        attributes: {
            'workflow.name': LOGIN_WORKFLOW_NAME,
            [LOGIN_TYPE_ATTRIBUTE]: loginType,
        },
    });
    let completed = false;

    return {
        end(success) {
            if (completed) {
                return;
            }
            completed = true;
            if (success === true) {
                span.setStatus({ code: SpanStatusCode.OK });
            } else if (success === false) {
                span.setStatus({ code: SpanStatusCode.ERROR });
            }
            span.end();
        },
    };
}
